var map = {
	"./accionaenergia.svg": "996a",
	"./accionaenergia2.svg": "d32f",
	"./canal.svg": "f7ad",
	"./correos.jpg": "9775",
	"./correos.svg": "585f",
	"./demo.svg": "3bea",
	"./eiffage.svg": "84a4",
	"./hipoges.svg": "990d",
	"./lyntia.png": "e3d3",
	"./lyntia.svg": "3d06",
	"./ohla.svg": "9341",
	"./quironocr.svg": "6033",
	"./redes.svg": "703e",
	"./ree.svg": "104a",
	"./renfe.svg": "a32e",
	"./tee.svg": "ced1",
	"./ufgas.svg": "43e5",
	"./vocento.svg": "0464"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8763";